import { timeDelivery, urls } from '../constants/app';
import request from './utils/request';
import { setError, resetError } from './errors';
import { addChanel } from './messages';
import { changeStatusPointKuper, changeStopListKuper, changeTimePointKuper } from './kuper';

export function setAddCity(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) {
            dispatch(resetError('addCity'));
        }
    }
}

export function fetchCities(isGetAll = false, withoutCount = false) {    
    return async (dispatch, getState) => {    
    dispatch({ type: 'SET_LOADER', field: 'cities', value: true });
    const user = getState().user.info;
    
    const paging = getState().handbook.paging.city;
    const sorting = getState().handbook.sorting.city;
    const currentCount = getState().handbook.count.cities;

    const params = {};
    if (!isGetAll) {
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
    } 

    if(user.points) {
        const cityId = user.points.reduce((acc, item) => {
            if(!acc.includes(item.city)){
                acc.push(item.city)
            }
            return acc
        }, []);
        params['id_in'] = cityId;
    }
    
    params['_sort'] = `${sorting.field}:${sorting.type}`;

    try {
        if (!withoutCount && currentCount === 0) {
            const count = await request({ method: 'get', url: urls.cities+'/count' });
            dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'cities' });
        }
        const data = await request({ method: 'get', url: urls.cities+'/crm', params });
        dispatch({ type: 'SET_HANDBOOK', field: 'cities', data });
        dispatch({ type: 'SET_LOADER', field: 'cities', value: false });
    } catch(error) {
        dispatch(setError(error, 'cities'));
        dispatch({ type: 'SET_LOADER', field: 'cities', value: false });
    }
}
}

export function fetchCity(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'city', value: true });

    return request({ method: 'get', url: `${urls.cities}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'city', data: response });
            dispatch({ type: 'SET_LOADER', field: 'city', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'cities'));
            dispatch({ type: 'SET_LOADER', field: 'city', value: false });
            return null
        });
    }
}

export function clearStateHandbook(field) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_COUNT', count: 0, field });
        dispatch({ type: 'SET_HANDBOOK', field, data: null });
        dispatch({ type: 'SET_LOADER', field, value: true });
    }
}

export function fetchZones(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'zones', value: true });

    return request({ method: 'get', url: `${urls.zone}/crm`, params: { 'city.id': id } })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK', field: 'zones', data: response });
            dispatch({ type: 'SET_LOADER', field: 'zones', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'cities'));
            dispatch({ type: 'SET_LOADER', field: 'zones', value: false });
            return null
        });
    }
}

export function fetchZonesByCities() {
    return (dispatch, getState) => {
        const cities = getState().handbook.cities;

        dispatch({ type: 'SET_LOADER', field: 'zones', value: true });

        return request({ method: 'get', url: `${urls.zone}/crm`, params: { 'city.id_in': cities.map(city => city.id) } })
            .then((response) => {
                dispatch({ type: 'SET_HANDBOOK', field: 'zones', data: response });
                dispatch({ type: 'SET_LOADER', field: 'zones', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError(error, 'cities'));
                dispatch({ type: 'SET_LOADER', field: 'zones', value: false });
                return null
            });
    }   
}

export function fetchFilial(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'filial', value: true });

    return request({ method: 'get', url: `${urls.filials}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'filial', data: response });
            dispatch({ type: 'SET_LOADER', field: 'filial', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'filial'));
            dispatch({ type: 'SET_LOADER', field: 'filial', value: false });
            return null
        });
    }
}

export function fetchZone(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'zone', value: true });

    return request({ method: 'get', url: `${urls.zone}/${id}`, params: { isCrm: true } })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'zone', data: response });
            dispatch({ type: 'SET_LOADER', field: 'zone', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'zone'));
            dispatch({ type: 'SET_LOADER', field: 'zone', value: false });
            return null
        });
    }
}

export function setCityEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'city', data });
    }
}

export function setFilialEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'filial', data });
    }
}

export function addFilialsEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'ADD_EDIT_FILIALS', data });
    }
}

export function changeFilialsEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'CHANGE_EDIT_FILIALS', data });
    }
}

export function removeFilialsEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'REMOVE_EDIT_FILIALS', data });
    }
}

export function setZoneEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'zone', data });
    }
}

export function fetchFilials(cityId, isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'filials', value: true });
    const paging = getState().handbook.paging.filial;
    const sorting = getState().handbook.sorting.filial;
    const filters = getState().handbook.filters.filial;
    const currentCount = getState().handbook.count.filials;
    const user = getState().user.info;

    const params = {};
    const dataParams = {};
    if (!isGetAll) {
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
    }

    if (filters.city) {
        dataParams['city.id'] = filters.city.value;
        params['city.id'] = filters.city.value;
    }

    params['_sort'] = `${sorting.field}:${sorting.type}`;


    if (cityId) {
        params['city.id'] = cityId;
    }

    if(user.points) {
        const pointsId = user.points.map(item => item.id);
        params['id_in'] = pointsId;
        dataParams['id_in'] = pointsId;
    }

    try {
        if (!withoutCount && currentCount === 0) {
            const count = await request({ method: 'get', url: urls.filials+'/count', params: dataParams });
            dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'filials' });
        }
        const data = await request({ method: 'get', url: urls.filials + '/crm', params });

        const renderAdress = (item) => {
            return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
        };

        const sorted = data.sort((a, b) => {
            const adressA = renderAdress(a);
            const adressB = renderAdress(b);
            if (adressA < adressB) return -1;
            if (adressA > adressB) return 1;
            return 0;
        });
        
        dispatch({ type: 'SET_HANDBOOK', field: 'filials', data: sorted });
        dispatch({ type: 'SET_LOADER', field: 'filials', value: false });
    } catch(error) {
        dispatch(setError(error, 'filials'));
        dispatch({ type: 'SET_LOADER', field: 'filials', value: false });
    }
    }
}

export function addCity(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addCity', value: true });

    return request({ method: 'post', url: urls.cities, data })
        .then((response) => {
            const chanel = {
                title: response.name,
                key: 'city',
                value: response.id
            };
            return addChanel(chanel).then(() => {
                dispatch({ type: 'SET_LOADER', field: 'addCity', value: false });
                return true;
            }).catch(() => {
                dispatch(setError({ status: 506 }, 'addCity'));
                dispatch({ type: 'SET_LOADER', field: 'addCity', value: false });
                return false;
            });
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addCity'));
            dispatch({ type: 'SET_LOADER', field: 'addCity', value: false });
            return false;
        });
    }
}

export function updateCity(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editCity', value: true });
    dispatch(resetError('editCity'));
    return request({ method: 'put', url: `${urls.cities}/${id}`, data })
        .then((response) => {
            if(data.hiddenClient && data.points)
            {
                data.points.map(async (item) => {
                    const pointData = {...item, hiddenClient: true, minDeliveryTime: timeDelivery.minDeliveryTime, minSamTime: timeDelivery.minSamTime, activate: 'disabledAll'}
                    return request({ method: 'put', url: `${urls.filials}/${item.id}`, data: pointData })
                    .then((response) => {
                        return true;
                    })
                    .catch(error => {
                        dispatch(setError({ status: 508 }, 'editCity'));
                        return false;
                    });
                })
            
            }
            dispatch({ type: 'SET_LOADER', field: 'editCity', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editCity'));
            dispatch({ type: 'SET_LOADER', field: 'editCity', value: false });
            return false;
        });
    }
}

export function updateFilial(id, data) {
    return async (dispatch, getState) => {
    const city = await getState().handbook.cities.find((item) => item.id === data.city.id)
    
    dispatch({ type: 'SET_LOADER', field: 'editFilial', value: true });

    /*if (data.integration && (data.changeStopList || data.changeActivateYE)) { Пока нет доступа к push модели функия не работает
        const YandexData = await axios.post(
            'yandexURL/oauth2/token',
            {
                data: {
                    client_id: data.clietnId || null,
                    client_secret: data.clientSecret || null
                }
            }
        )

        if (YandexData.error || !YandexData.access_token) {
            dispatch(setError({ status: 508 }, 'editFilial'));
            dispatch({ type: 'SET_LOADER', field: 'editFilial', value: false });
            return false;
        }

        const token = YandexData.access_token;
        const tokenType = YandexData.token_type || 'Bearer';

        if (data.changeStopList) {
            await axios.post(
                'yandexURL/menu/import/initiation',
                {
                    headers: {
                        Authorization: `${tokenType} ${token}`,
                        'Partner-Name': 'SUSHIBOX'
                    },
                    data: {
                        restaurantId: String(id),
                        operationType: "menu_stop_list"
                    }
                }
            ).catch(error => {
                console.error("Error:", error);
            });
        }

        if (data.changeActivateYE) {
            const aggData = {
                id,
                token,
                tokenType,
                ddc: (data.activateYE === 'disabled' || data.activateYE === 'disbledDDC') ? 'block' : 'unblock',
                marketplace: (data.activateYE === 'disabled' || data.activateYE === 'disabledMarketplace') ? 'block' : 'unblock',
            };
            await request({ method: 'post', url: `${urls.aggregators}/block`, data: aggData });
        }
    }*/


    if (data.integrationKuper && data.changeStopList) {
        const pointData = await request({ method: 'get', url: `${urls.filials}/${id}` })
        const prevStopList = pointData.stopList;

        function convertToSet(dat) {
            return new Set(dat.map(item => JSON.stringify(item)));
        }
        
        const prevSet = convertToSet(prevStopList);
        const dataSet = convertToSet(data.stopList);
        const deletedGoods = [...prevSet].filter(item => !dataSet.has(item)).map(JSON.parse)
        .map(item => {
            item.active = true;
            return item;
        });

        const addedGoods = data.stopList.map(item => {
            item.active = false;
            return item;
        });

        const arrayGoods = [...deletedGoods, ...addedGoods];
        dispatch(changeStopListKuper(id, arrayGoods))
    }

    if (data.changeActivateKuper) {
        let commentKuper = null;
        
        if (data.commentKuper) {
            commentKuper = data.commentKuper;
        } else {
            if (data.activateKuper === 'ACTIVE') commentKuper = 'Снова можем принимать заказы';
            if (data.activateKuper === 'INACTIVE') commentKuper = 'Временно не можем принимать заказы';
            if (data.activateKuper === 'DISCONNECTED') commentKuper = '-'
        }

        dispatch(changeStatusPointKuper(id, data.activateKuper, commentKuper));
    }

    if (data.integrationKuper && data.changeTime) {
        dispatch(changeTimePointKuper(id, data.minSamTime));
    }
    
    delete data.changeTime
    delete data.changeActivateYE;
    delete data.changeActivateKuper;
    delete data.commentKuper;
    
    return request({ method: 'put', url: `${urls.filials}/${id}`, data })
        .then((response) => {
            if(city)
            {
                if(!data.hiddenClient && city.hiddenClient)   
                {             
                    const cityData = {...city, hiddenClient: false}
                    return request({ method: 'put', url: `${urls.cities}/${city.id}`, data: cityData })
                    .then((response) => {
                        return true;
                    })
                    .catch(error => {
                        dispatch(setError({ status: 508 }, 'editFilial'));
                        return false;
                    });
                }
                if(data.hiddenClient && !city.hiddenClient)
                {
                    const cityData = {...city, hiddenClient: true}
                    const pointsChek = city.points.filter((item) => item.hiddenClient)
                    if(pointsChek.length + 1 === city.points.length)
                        return request({ method: 'put', url: `${urls.cities}/${city.id}`, data: cityData })
                        .then((response) => {
                            return true;
                        })
                        .catch(error => {
                            dispatch(setError({ status: 508 }, 'editFilial'));
                            return false;
                        });
                } 
            }            
            dispatch({ type: 'SET_LOADER', field: 'editFilial', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editFilial'));
            dispatch({ type: 'SET_LOADER', field: 'editFilial', value: false });
            return false;
        });
    }
}

export function removeUserPoint(id) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'removeUserPoint', value: true });
        return request({ method: 'put', url: `${urls.filials}/${id}/removeUserPoint` })
            .then(() => {
                dispatch({ type: 'SET_LOADER', field: 'removeUserPoint', value: false });
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'filials'));
                dispatch({ type: 'SET_LOADER', field: 'removeUserPoint', value: false });
                return false;
            });
    }
}

export function updateFilialsTimeDelivery(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'filials', value: true });

    return request({ method: 'put', url: `${urls.filials}/updateTimeDelivery`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'filials', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'filials'));
            dispatch({ type: 'SET_LOADER', field: 'filials', value: false });
            return false;
        });
    }
}

export function updateZone(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editZone', value: true });

    return request({ method: 'put', url: `${urls.zone}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editZone', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editZone'));
            dispatch({ type: 'SET_LOADER', field: 'editZone', value: false });
            return false;
        });
    }
}

export function deleteFilial(item) {
    return request({ method: 'delete', url: `${urls.filials}/${item.id}` })
        .then((response) => {
            return true;
        })
        .catch(error => {
            return false;
        });
}

export function activateFilial(item) {
    return request({ method: 'put', url: `${urls.filials}/${item.id}`, data: { stop: !item.stop } })
        .then((response) => {
            return true;
        })
        .catch(error => {
            return false;
        });
}

export function deleteZone(item) {
    return request({ method: 'delete', url: `${urls.zone}/${item.id}` })
        .then((response) => {
            return true;
        })
        .catch(error => {
            return false;
        });
}

export function deleteCity(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'cities', value: true });

        request({ method: 'delete', url: `${urls.cities}/${item.id}` })
            .then((response) => {
                dispatch(fetchCities());
                dispatch({ type: 'SET_LOADER', field: 'cities', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'cities'));
                dispatch({ type: 'SET_LOADER', field: 'cities', value: false });
            });
    }
}

export function addFilial(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addFilial', value: true });

    return request({ method: 'post', url: urls.filials, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'addFilial', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addFilial'));
            dispatch({ type: 'SET_LOADER', field: 'addFilial', value: false });
            return false;
        });
    }
}

export function addZone(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addZone', value: true });

    return request({ method: 'post', url: urls.zone, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'addZone', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addZone'));
            dispatch({ type: 'SET_LOADER', field: 'addZone', value: false });
            return false;
        });
    }
}

export function setHandbookPaging(field, paging) {
    return dispatch => {
        dispatch({ type: 'SET_HANDBOOK_PAGING', field, paging });
    }
}

export function setHandbookFilters(field, filters) {
    return dispatch => {
        dispatch({ type: 'SET_HANDBOOK_FILTERS', field, filters });
    }
}

export function fetchPayments(isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'payments', value: true });
    
    const paging = getState().handbook.paging.payments;
    const currentCount = getState().handbook.count.payments;

    const params = {};
    if (!isGetAll) {
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
    } 
    
    params['_sort'] = `name:asc`;

    try {
        if (!withoutCount && currentCount === 0) {
            const count = await request({ method: 'get', url: urls.payments+'/count' });
            dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'payments' });
        }
        const data = await request({ method: 'get', url: urls.payments, params });
        dispatch({ type: 'SET_HANDBOOK', field: 'payments', data });
        dispatch({ type: 'SET_LOADER', field: 'payments', value: false });
    } catch(error) {
        dispatch(setError(error, 'payments'));
        dispatch({ type: 'SET_LOADER', field: 'payments', value: false });
    }
}
}

export function fetchPayment(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'payments', value: true });

    return request({ method: 'get', url: `${urls.payments}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'payment', data: response });
            dispatch({ type: 'SET_LOADER', field: 'payments', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'payments'));
            dispatch({ type: 'SET_LOADER', field: 'payments', value: false });
            return null
        });
    }
}

export function deletePayment(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'payments', value: true });

        request({ method: 'delete', url: `${urls.payments}/${item.id}` })
            .then((response) => {
                dispatch(fetchPayments());
                dispatch({ type: 'SET_LOADER', field: 'payments', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'payments'));
                dispatch({ type: 'SET_LOADER', field: 'payments', value: false });
            });
    }
}

export function setAddPayment(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) {
            dispatch(resetError('addPayment'));
        }
    }
}

export function addPayment(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addPayment', value: true });

    return request({ method: 'post', url: urls.payments, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addPayment', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addPayment'));
            dispatch({ type: 'SET_LOADER', field: 'addPayment', value: false });
            return false;
        });
    }
}

export function setPaymentEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'payment', data });
    }
}

export function updatePayment(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editPayment', value: true });
    dispatch(resetError('editPayment'));
    return request({ method: 'put', url: `${urls.payments}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editPayment', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editPayment'));
            dispatch({ type: 'SET_LOADER', field: 'editPayment', value: false });
            return false;
        });
    }
}

export function fetchBlockedPhones(isGetAll = false, withoutCount = false) {    
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: true });
            dispatch(resetError('blockedPhones'));
            
            const user = getState().user.info;
            const paging = getState().handbook.paging.blockedPhones;
            const sorting = getState().handbook.sorting.blockedPhones;
            const currentCount = getState().handbook.count.blockedPhones;

            const params = {};
            if (!isGetAll) {
                params['_start'] = paging.start;
                params['_limit'] = paging.limit;
            } 

            if(user.points) {
                const cityId = user.points.reduce((acc, item) => {
                    if(!acc.includes(item.city)){
                        acc.push(item.city)
                    }
                    return acc
                }, []);
                params['id_in'] = cityId;
            }
            
            params['_sort'] = `${sorting.field}:${sorting.type}`;

            if (!withoutCount && currentCount === 0) {
                const count = await request({ method: 'get', url: urls.blockedPhones+'/count' });
                dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'blockedPhones' });
            }
            
            const data = await request({ method: 'get', url: urls.blockedPhones, params });
            
            dispatch({ type: 'SET_HANDBOOK', field: 'blockedPhones', data });
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            
            return data;
        } catch(error) {
            dispatch(setError(error, 'blockedPhones'));
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            throw error;
        }
    }
}

export function addBlockedPhone(data) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: true });
            dispatch(resetError('blockedPhones'));

            if (!data.phone) {
                throw new Error('Необходимо заполнить телефон');
            }

            const response = await request({ method: 'post', url: urls.blockedPhones, data });
            
            dispatch(fetchBlockedPhones());
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            
            return response;
        } catch (error) {
            dispatch(setError(error, 'blockedPhones'));
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            throw error;
        }
    };
}

export function updateBlockedPhone(id, data) {
    return async (dispatch) => {
        try {
            const url = urls.blockedPhones;
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: true });
            dispatch(resetError('blockedPhones'));

            if (!data.phone && !data.comment) {
                throw new Error('Необходимо заполнить телефон или комментарий');
            }

            const response = await request({ method: 'put', url: `${url}/${id}`, data });
            
            dispatch({ type: 'UPDATE_BLOCKED_PHONE', blockedPhones: response });
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            
            return response;
        } catch (error) {
            dispatch(setError({ status: 508 }, 'blockedPhones'));
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            throw error;
        }
    }
}

export function deleteBlockedPhoneById(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: true });
            dispatch(resetError('blockedPhones'));

            if (!id) {
                throw new Error('ID записи не указан');
            }

            const response = await request({ method: 'delete', url: `${urls.blockedPhones}/${id}` });
            
            dispatch({ type: 'REMOVE_BLOCKED_PHONE', id });
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            
            return response;
        } catch (error) {
            dispatch(setError({ status: 507 }, 'blockedPhones'));
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            throw error;
        }
    }
}

export function fetchAllBlockedPhones() {    
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: true });
            
            const user = getState().user.info;
            const sorting = getState().handbook.sorting.blockedPhones;

            const params = {
                '_sort': `${sorting.field}:${sorting.type}`
            };

            if(user.points) {
                const cityId = user.points.reduce((acc, item) => {
                    if(!acc.includes(item.city)){
                        acc.push(item.city)
                    }
                    return acc
                }, []);
                params['id_in'] = cityId;
            }
            
            const blockedPhones = await request({ method: 'get', url: urls.blockedPhones, params });
            
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            
            return blockedPhones;
        } catch(error) {
            dispatch(setError(error, 'blockedPhones'));
            dispatch({ type: 'SET_LOADER', field: 'blockedPhones', value: false });
            throw error;
        }
    }
}

export function addBlockedPhones(phonesData) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'import', value: true });
            dispatch(resetError('blockedPhones'));

            const response = await request({ 
                method: 'post', 
                url: `/addBlockedPhones`, 
                data: { phones: phonesData }
            });
            
            dispatch(fetchBlockedPhones());
            
            dispatch({ type: 'SET_LOADER', field: 'import', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'blockedPhones'));
            dispatch({ type: 'SET_LOADER', field: 'import', value: false });
            throw error;
        }
    }
}

export function fetchTags(isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'tags', value: true });
        
        const paging = getState().handbook.paging.tags;
        const currentCount = getState().handbook.count.tags;
        const params = {};
        if (!isGetAll) {
            params['_start'] = paging.start;
            params['_limit'] = paging.limit;
        } 
        
        params['_sort'] = `name:asc`;
        try {
            if (!withoutCount && currentCount === 0) {
                const count = await request({ method: 'get', url: urls.tags+'/count' });
                dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'tags' });
            }
            const data = await request({ method: 'get', url: urls.tags, params });
            dispatch({ type: 'SET_HANDBOOK', field: 'tags', data });
            dispatch({ type: 'SET_LOADER', field: 'tags', value: false });
        } catch(error) {
            dispatch(setError(error, 'tags'));
            dispatch({ type: 'SET_LOADER', field: 'tags', value: false });
        }
    }
}

export function fetchTag(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'tags', value: true });
    return request({ method: 'get', url: `${urls.tags}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'tag', data: response });
            dispatch({ type: 'SET_LOADER', field: 'tags', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'tags'));
            dispatch({ type: 'SET_LOADER', field: 'tags', value: false });
            return null
        });
    }
}

export function deleteTag(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'tags', value: true });
        request({ method: 'delete', url: `${urls.tags}/${item.id}` })
            .then((response) => {
                dispatch(fetchTags());
                dispatch({ type: 'SET_LOADER', field: 'tags', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'tags'));
                dispatch({ type: 'SET_LOADER', field: 'tags', value: false });
            });
    }
}

export function setAddTag(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) dispatch(resetError('addTag'));
    }
}

export function addTag(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addTag', value: true });
    return request({ method: 'post', url: urls.tags, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addTag', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addTag'));
            dispatch({ type: 'SET_LOADER', field: 'addTag', value: false });
            return false;
        });
    }
}

export function setTagEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'tag', data });
    }
}

export function updateTag(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editTag', value: true });
    dispatch(resetError('editTag'));
    return request({ method: 'put', url: `${urls.tags}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editTag', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editTag'));
            dispatch({ type: 'SET_LOADER', field: 'editTag', value: false });
            return false;
        });
    }
}

export function fetchArticlesCash(isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'articlesCash', value: true });
        
        const paging = getState().handbook.paging.articlesCash;
        const currentCount = getState().handbook.count.articlesCash;
        const params = {};
        if (!isGetAll) {
            params['_start'] = paging.start;
            params['_limit'] = paging.limit;
        } else {
            params['_limit'] = -1;
            params['_start'] = 0;
        }
        
        params['_sort'] = `name:asc`;
        try {
            if (!withoutCount && currentCount === 0) {
                const count = await request({ method: 'get', url: urls.articlesCash+'/count' });
                dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'articlesCash' });
            }
            const data = await request({ method: 'get', url: urls.articlesCash, params });
            dispatch({ type: 'SET_HANDBOOK', field: 'articlesCash', data });
            dispatch({ type: 'SET_LOADER', field: 'articlesCash', value: false });
        } catch(error) {
            dispatch(setError(error, 'articlesCash'));
            dispatch({ type: 'SET_LOADER', field: 'articlesCash', value: false });
        }
    }
}

export function fetchArticleCash(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'articleCash', value: true });
    return request({ method: 'get', url: `${urls.articlesCash}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'articleCash', data: response });
            dispatch({ type: 'SET_LOADER', field: 'articleCash', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'articlesCash'));
            dispatch({ type: 'SET_LOADER', field: 'articleCash', value: false });
            return null
        });
    }
}

export function deleteArticleCash(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'articlesCash', value: true });
        request({ method: 'delete', url: `${urls.articlesCash}/${item.id}` })
            .then((response) => {
                dispatch(fetchArticlesCash());
                dispatch({ type: 'SET_LOADER', field: 'articlesCash', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'articlesCash'));
                dispatch({ type: 'SET_LOADER', field: 'articlesCash', value: false });
            });
    }
}

export function setAddArticleCash(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) dispatch(resetError('addArticleCash'));
    }
}

export function addArticleCash(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addArticleCash', value: true });
    return request({ method: 'post', url: urls.articlesCash, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addArticleCash', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addArticleCash'));
            dispatch({ type: 'SET_LOADER', field: 'addArticleCash', value: false });
            return false;
        });
    }
}

export function setArticleCashEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'articleCash', data });
    }
}

export function updateArticleCash(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editArticleCash', value: true });
    dispatch(resetError('editArticleCash'));
    return request({ method: 'put', url: `${urls.articlesCash}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editArticleCash', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editArticleCash'));
            dispatch({ type: 'SET_LOADER', field: 'editArticleCash', value: false });
            return false;
        });
    }
}

export function fetchArticlesExpenditures(isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: true });
        
        const paging = getState().handbook.paging.articlesExpenditures;
        const currentCount = getState().handbook.count.articlesExpenditures;
        const params = {};
        if (!isGetAll) {
            params['_start'] = paging.start;
            params['_limit'] = paging.limit;
        } else {
            params['_start'] = 0;
            params['_limit'] = -1;
        }
        
        params['_sort'] = `name:asc`;
        try {
            if (!withoutCount && currentCount === 0) {
                const count = await request({ method: 'get', url: urls.articlesExpenditures+'/count' });
                dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'articlesExpenditures' });
            }
            const data = await request({ method: 'get', url: urls.articlesExpenditures, params });
            dispatch({ type: 'SET_HANDBOOK', field: 'articlesExpenditures', data });
            dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: false });
        } catch(error) {
            dispatch(setError(error, 'articleExpenditures'));
            dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: false });
        }
    }
}

export function fetchArticleExpenditures(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: true });
    return request({ method: 'get', url: `${urls.articlesExpenditures}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'articleExpenditures', data: response });
            dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'articleExpenditures'));
            dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: false });
            return null
        });
    }
}

export function deleteArticleExpenditures(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: true });
        request({ method: 'delete', url: `${urls.articlesExpenditures}/${item.id}` })
            .then((response) => {
                dispatch(fetchArticlesExpenditures());
                dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'articleExpenditures'));
                dispatch({ type: 'SET_LOADER', field: 'articleExpenditures', value: false });
            });
    }
}

export function setAddArticleExpenditures(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) dispatch(resetError('addArticleExpenditures'));
    }
}

export function addArticleExpenditures(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addArticleExpenditures', value: true });
    return request({ method: 'post', url: urls.articlesExpenditures, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addArticleExpenditures', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addArticleExpenditures'));
            dispatch({ type: 'SET_LOADER', field: 'addArticleExpenditures', value: false });
            return false;
        });
    }
}

export function setArticleExpendituresEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'articleExpenditures', data });
    }
}

export function updateArticleExpenditures(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editArticleExpendituresh', value: true });
    dispatch(resetError('editArticleExpenditures'));
    return request({ method: 'put', url: `${urls.articlesExpenditures}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editArticleExpenditures', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editArticleExpenditures'));
            dispatch({ type: 'SET_LOADER', field: 'editArticleExpenditures', value: false });
            return false;
        });
    }
}

export function fetchWebhooks(isGetAll = false, withoutCount = false) {    
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: true });
            dispatch(resetError('webhooks'));
            
            const paging = getState().handbook.paging.webhooks;
            const sorting = getState().handbook.sorting.webhooks;
            const currentCount = getState().handbook.count.webhooks;

            const params = {};
            if (!isGetAll) {
                params['_start'] = paging.start;
                params['_limit'] = paging.limit;
            }
            
            params['_sort'] = `${sorting.field}:${sorting.type}`;

            if (!withoutCount && currentCount === 0) {
                const webhooks = await request({ method: 'get', url: `${urls.webhooks}` });
                dispatch({ type: 'SET_HANDBOOK_COUNT', count: webhooks.length, field: 'webhooks' });
                dispatch({ type: 'SET_HANDBOOK', field: 'webhooks', data: webhooks });
            } else {
                const webhooks = await request({ method: 'get', url: `${urls.webhooks}` });
                dispatch({ type: 'SET_HANDBOOK', field: 'webhooks', data: webhooks });
            }
            
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
        } catch(error) {
            dispatch(setError(error, 'webhooks'));
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            throw error;
        }
    }
}

export function addWebhook(data) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: true });
            dispatch(resetError('webhooks'));

            if (!data.url) {
                throw new Error('Необходимо заполнить URL');
            }

            const response = await request({ method: 'post', url: `${urls.webhooks}`, data });
            
            dispatch(fetchWebhooks());
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            
            return response;
        } catch (error) {
            dispatch(setError(error, 'webhooks'));
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            throw error;
        }
    };
}

export function updateWebhook(id, data = {}) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: true });
            dispatch(resetError('webhooks'));

            if (!data.secret) {
                throw new Error('Необходимо указать текущий secret вебхука');
            }

            if (data.url === undefined && data.name === undefined && data.isActive === undefined && data.newSecret === undefined) {
                throw new Error('Необходимо изменить хотя бы одно поле');
            }

            const response = await request({ method: 'put', url: `${urls.webhooks}/${id}`, data });
            
            dispatch({ type: 'UPDATE_WEBHOOK', webhook: response.webhook });
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            
            return response;
        } catch (error) {
            dispatch(setError(error, 'webhooks'));
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            throw error;
        }
    }
}

export function deleteWebhookById(id, secret) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: true });
            dispatch(resetError('webhooks'));

            if (!id) {
                throw new Error('ID записи не указан');
            }

            if (!secret) {
                throw new Error('Secret вебхука не указан');
            }

            const response = await request({ 
                method: 'delete', 
                url: `${urls.webhooks}/${id}`,
                params: { secret }
            });
            
            dispatch({ type: 'REMOVE_WEBHOOK', id });
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            
            return response;
        } catch (error) {
            dispatch(setError(error, 'webhooks'));
            dispatch({ type: 'SET_LOADER', field: 'webhooks', value: false });
            throw error;
        }
    }
}

export function fetchSources(isGetAll = false, withoutCount = false, returnSources = false) {
    return async (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'sources', value: true });
    
    const paging = getState().handbook.paging.sources;
    const currentCount = getState().handbook.count.sources;

    const params = {};
    if (!isGetAll) {
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
    } 
    
    params['_sort'] = `name:asc`;

    try {
        if (!withoutCount && currentCount === 0) {
            const count = await request({ method: 'get', url: urls.sources+'/count' });
            dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'sources' });
        }
        const data = await request({ method: 'get', url: urls.sources, params });
        dispatch({ type: 'SET_HANDBOOK', field: 'sources', data });
        dispatch({ type: 'SET_LOADER', field: 'sources', value: false });
        if (returnSources) return data;
    } catch(error) {
        dispatch(setError(error, 'sources'));
        dispatch({ type: 'SET_LOADER', field: 'sources', value: false });
    }
}
}

export function fetchSource(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'sources', value: true });

    return request({ method: 'get', url: `${urls.sources}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'source', data: response });
            dispatch({ type: 'SET_LOADER', field: 'sources', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'sources'));
            dispatch({ type: 'SET_LOADER', field: 'sources', value: false });
            return null
        });
    }
}

export function deleteSource(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'sources', value: true });

        request({ method: 'delete', url: `${urls.sources}/${item.id}` })
            .then((response) => {
                dispatch(fetchSources());
                dispatch({ type: 'SET_LOADER', field: 'sources', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'sources'));
                dispatch({ type: 'SET_LOADER', field: 'sources', value: false });
            });
    }
}

export function setAddSource(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) {
            dispatch(resetError('addSource'));
        }
    }
}

export function addSource(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addSource', value: true });

    return request({ method: 'post', url: urls.sources, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addSource', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addSource'));
            dispatch({ type: 'SET_LOADER', field: 'addSource', value: false });
            return false;
        });
    }
}

export function setSourceEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'source', data });
    }
}

export function updateSource(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editSource', value: true });
    dispatch(resetError('editSource'));
    return request({ method: 'put', url: `${urls.sources}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editSource', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editSource'));
            dispatch({ type: 'SET_LOADER', field: 'editSource', value: false });
            return false;
        });
    }
}

export function fetchArticlesCashCategories(isGetAll = false, withoutCount = false) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'articlesCashCategories', value: true });
        
        const paging = getState().handbook.paging.articlesCashCategories;
        const currentCount = getState().handbook.count.articlesCashCategories;
        const params = {};
        if (!isGetAll) {
            params['_start'] = paging.start;
            params['_limit'] = paging.limit;
        } else {
            params['_start'] = 0;
            params['_limit'] = -1;
        }
        
        params['_sort'] = `name:asc`;
        try {
            if (!withoutCount && currentCount === 0) {
                const count = await request({ method: 'get', url: urls.articlesCashCategories+'/count' });
                dispatch({ type: 'SET_HANDBOOK_COUNT', count, field: 'articlesCashCategories' });
            }
            const data = await request({ method: 'get', url: urls.articlesCashCategories, params });
            dispatch({ type: 'SET_HANDBOOK', field: 'articlesCashCategories', data });
            dispatch({ type: 'SET_LOADER', field: 'articlesCashCategories', value: false });
        } catch(error) {
            dispatch(setError(error, 'articlesCashCategories'));
            dispatch({ type: 'SET_LOADER', field: 'articlesCashCategories', value: false });
        }
    }
}

export function fetchArticlesCashCategory(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'articlesCashCategory', value: true });
    return request({ method: 'get', url: `${urls.articlesCashCategories}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_HANDBOOK_DETAIL', field: 'articlesCashCategory', data: response });
            dispatch({ type: 'SET_LOADER', field: 'articlesCashCategory', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'articlesCashCategory'));
            dispatch({ type: 'SET_LOADER', field: 'articlesCashCategory', value: false });
            return null
        });
    }
}

export function deleteArticleCashCategory(item) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'articlesCashCategory', value: true });
        request({ method: 'delete', url: `${urls.articlesCashCategories}/${item.id}` })
            .then((response) => {
                dispatch(fetchArticlesCashCategories());
                dispatch({ type: 'SET_LOADER', field: 'articlesCashCategory', value: false });
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'articlesCashCategory'));
                dispatch({ type: 'SET_LOADER', field: 'articlesCashCategory', value: false });
            });
    }
}

export function setAddArticlesCashCategory(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_HANDBOOK', data });
        if (!data.name) dispatch(resetError('articlesCashCategories'));
    }
}

export function addArticlesCashCategory(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addArticlesCashCategory', value: true });
    return request({ method: 'post', url: urls.articlesCashCategories, data })
        .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'addArticlesCashCategory', value: false });
                return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addArticlesCashCategory'));
            dispatch({ type: 'SET_LOADER', field: 'addArticlesCashCategory', value: false });
            return false;
        });
    }
}

export function setArticlesCashCategoyEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_HANDBOOK_EDIT', field: 'articlesCashCategory', data });
    }
}

export function updateArticlesCashCategory(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'editArticleCashCategory', value: true });
    dispatch(resetError('editArticleCashCategory'));
    return request({ method: 'put', url: `${urls.articlesCashCategories}/${id}`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'editArticleCashCategory', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 508 }, 'editArticleCashCategory'));
            dispatch({ type: 'SET_LOADER', field: 'editArticleCashCategory', value: false });
            return false;
        });
    }
}

export function createCommission(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'commission', value: true });
        dispatch(resetError('commission'));
        return request({ method: 'post', url: urls.commissions, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'commission', value: false });
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'commission'));
                dispatch({ type: 'SET_LOADER', field: 'commission', value: false });
                return false;
            });
    }
}

export function deleteCommission(id) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'commissions', value: true });
        request({ method: 'delete', url: `${urls.commissions}/${id}` })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'commissions', value: false });
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'commissions'));
                dispatch({ type: 'SET_LOADER', field: 'commissions', value: false });
                return false;
            });
    }
}

export function updateCommission(data, id) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'commission', value: true });
        dispatch(resetError('commission'));
        return request({ method: 'put', url: `${urls.commissions}/${id}`, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'commission', value: false });
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'commission'));
                dispatch({ type: 'SET_LOADER', field: 'commission', value: false });
                return false;
            });
    }
}